import { useState, useRef, useCallback, useEffect } from "react";

import {
  PassWord,
  Button,
  Input as Inputcmp,
  Select,
} from "./../../component/pass_input";

import { message, Icon, Input } from "antd";

import { isRegister } from "./../../global_action";

import {
  CountryCode,
  emailCheck,
  passwordLogincheck,
  NewPhoneCheck,
} from "./../../global_cig";

import Axios from "axios";
import { Getgraph } from "./login-api";

const UserInputComponent = (props) => {
  let { flag, placeholder, value } = props;
  const onChange = (data) => {
    props.onChange(data);
  };
  useEffect(() => {
    if (value) {
      onChange(value);
    }
  }, [value]);
  const prefixSelector = (
    <Select
      className="select_active"
      style={{
        height: 36,
        width: "35%",
        margin: 0,
        backgroundColor: "rgba(34,34,34,1)",
        color: "#fff",
        borderRadius: 0,
      }}
      onChange={(value) => {
        onChange({ countryCode: value });
      }}
      children={CountryCode}
    />
  );
  return flag ? (
    <Inputcmp
      defalutValue={value}
      style={{ width: "63%", marginLeft: "2%", borderRadius: 0 }}
      placeholder={placeholder}
      onChange={({ target: { value } }) =>
        onChange({ userName: value.startsWith("0") ? value.substr(1) : value })
      }
      addonBefore={prefixSelector}
    />
  ) : (
    <Inputcmp
      defalutValue={value}
      style={{ borderRadius: 0 }}
      onChange={({ target: { value } }) => onChange({ userName: value })}
      placeholder={placeholder}
    />
  );
};

const PassWordComponent = (props) => {
  const onChange = ({ target: { value } }) => {
    props.onChange(value);
  };

  return <PassWord {...props} onChange={onChange} value={props.initValue} />;
};

const GraphCaptach = (props) => {
  const [graph, setGraph] = useState({ captchaId: "", image: "" });
  let { dispatch, hasError } = props;
  const getGraph = async () => {
    let res = await Getgraph();
    if (res.code !== 0) {
      message.error(res.message);
    } else {
      dispatch({ captchaId: res.data.captchaId, captcha: "", hasError: false });
      setGraph((state) => ({
        ...state,
        captchaId: res.data.captchaId,
        image: res.data.image,
      }));
    }
  };
  useEffect(() => {
    if (hasError) {
      getGraph();
    }
  }, [hasError]);
  useEffect(() => {
    getGraph();
  }, []);
  return (
    <div style={{ float: "left", width: "40%" }}>
      <div
        onClick={() => {
          getGraph();
        }}
      >
        <img
          src={graph.image}
          width={"106px"}
          height={"36px"}
          style={{ objectFit: "contain" }}
        />
      </div>
    </div>
  );
};

const CaptchaComponent = (props) => {
  let [code, setCode] = useState(0);
  var str = true;
  let { userName, countryCode, security, action, checked, isPhone, isback } =
    props;

  const SetButton = (index = 59) => {
    setCode(60);
    var timer = setInterval(() => {
      if (str) {
        setCode(index--);
      }
      if (index < 0 || !str) {
        clearInterval(timer);
      }
    }, 1000);
  };

  const BuildCaptcha = useCallback(async () => {
    let value = { action, unique: false };
    if (!userName) {
      if (isPhone) {
        if (!userCheck(userName)) {
          message.destroy();
          message.error("格式错误");
          return;
        }
        message.destroy();
        message.error("请输入手机号");
      }
      return;
    }
    if (isPhone) {
      if (passwordLogincheck(`${countryCode}${userName}`) === "") {
        message.destroy();
        message.error("手机号格式错误");
        return;
      }
      let { newName } = NewPhoneCheck(countryCode, userName);
      let isRegist = await isRegister(`${countryCode}-${newName}`);
      if (!isRegist) {
        message.destroy();
        message.error("此手机号尚未注册");
        return;
      }
    }

    if (!checked && !checkFn({ userName })) {
      message.destroy();
      message.error("格式错误");
      return;
    }

    if (userName.match(/@/g) !== null) {
      value = { ...value, email: userName };
    } else {
      if (action === 2) {
        value = {
          ...value,
          mobileNumber: userName,
          countryCode,
        };
      } else {
        value = {
          ...value,
          mobileNumber: userName,
          countryCode,
        };
      }
    }
    let { email } = value;
    let res;
    if (email) {
      res = await Axios.post("/captcha/email", value);
    } else {
      res = await Axios.post("/captcha/sms", value);
    }
    if (res.data.code !== 0) {
      message.destroy();
      message.error(res.data.message);
      SetButton();
    } else {
      message.success("发送成功");
      SetButton();
    }
  }, [userName, countryCode, action, checked, isPhone]);
  useEffect(() => {
    str = true;
    !security && BuildCaptcha();
    return () => {
      str = false;
    };
  }, [security, BuildCaptcha]);
  return (
    <div style={{ float: "left", width: "40%" }}>
      {code === 0 ? (
        <Button
          onClick={BuildCaptcha}
          text={"获取验证码"}
          type="button"
          className="yzm_bt"
        />
      ) : (
        <Button
          type="button"
          text={`重发验证码(${code})`}
          className="yzm_bt_active"
        />
      )}
    </div>
  );
};
const CaptchaComponentLogin = (props) => {
  let [code, setCode] = useState(0);
  var str = true;
  let {
    userName,
    countryCode,
    captchaValue,
    captchaId,
    action,
    checked,
    isPhone,
    isNeedGraph,
    dispatch,
  } = props;
  const SetButton = (index = 59) => {
    setCode(60);
    var timer = setInterval(() => {
      if (str) {
        setCode(index--);
      }
      if (index < 0 || !str) {
        clearInterval(timer);
      }
    }, 1000);
  };

  const BuildCaptcha = useCallback(async () => {
    let value = { action, unique: false };
    if (isPhone && userName === "") {
      message.destroy();
      message.error("请输入手机号");
      return;
    }
    if (userName !== "") {
      if (isPhone) {
        if (!userCheck(userName)) {
          message.destroy();
          message.error("格式错误");
          return;
        }
      }
    }

    if (isPhone) {
      if (passwordLogincheck(`${countryCode}${userName}`) === "") {
        message.destroy();
        message.error("手机号格式错误");
        return;
      }
      let { newName } = NewPhoneCheck(countryCode, userName);
      let isRegist = await isRegister(`${countryCode}-${newName}`);
      if (!isRegist) {
        message.destroy();
        message.error("此手机号尚未注册");
        return;
      }
    }
    if (isNeedGraph && captchaValue === "") {
      message.error("请输入图形验证码");
      return;
    }
    if (!checked && !checkFn({ userName })) {
      message.destroy();
      message.error("格式错误");
      return;
    }

    if (userName.match(/@/g) !== null) {
      value = { ...value, email: userName };
    } else {
      value = isNeedGraph
        ? {
            ...value,
            mobileNumber: userName,
            captchaId,
            countryCode,
            captchaValue,
          }
        : {
            ...value,
            mobileNumber: userName,
            countryCode,
          };
    }
    let { email } = value;
    let res;
    if (email) {
      res = await Axios.post("/captcha/email", value);
    } else {
      res = await Axios.post("/v2/captcha/sms", value);
    }
    if (res.data.code !== 0) {
      message.destroy();
      message.error(res.data.message);
      dispatch({ hasError: true });
      // SetButton();
    } else {
      message.success("发送成功");
      dispatch({ isSend: true });
      SetButton();
    }
  }, [
    userName,
    countryCode,
    action,
    checked,
    isPhone,
    captchaValue,
    captchaId,
  ]);

  // useEffect(() => {
  //   str = true;
  //   !isNeedGraph && BuildCaptcha();
  //   return () => {
  //     str = false;
  //   };
  // }, [isNeedGraph, BuildCaptcha]);
  return (
    <div style={{ float: "left", width: "40%" }}>
      {code === 0 ? (
        <Button
          onClick={BuildCaptcha}
          text={"获取验证码"}
          type="button"
          className="yzm_bt"
        />
      ) : (
        <Button
          type="button"
          text={`重发验证码(${code})`}
          className="yzm_bt_active"
        />
      )}
    </div>
  );
};
const CaptchaComponentRegist = (props) => {
  let [code, setCode] = useState(0);
  var str = true;
  let {
    userName,
    countryCode,
    captchaValue,
    captchaId,
    action,
    checked,
    isPhone,
    isNeedGraph,
    dispatch,
  } = props;
  const SetButton = (index = 59) => {
    setCode(60);
    var timer = setInterval(() => {
      if (str) {
        setCode(index--);
      }
      if (index < 0 || !str) {
        clearInterval(timer);
      }
    }, 1000);
  };

  const BuildCaptcha = useCallback(async () => {
    let value = { action, unique: false };
    if (isPhone && userName === "") {
      message.destroy();
      message.error("请输入手机号");
      return;
    }
    if (userName !== "") {
      if (isPhone) {
        if (!userCheck(userName)) {
          message.destroy();
          message.error("格式错误");
          return;
        }
      }
    }

    if (isPhone) {
      if (passwordLogincheck(`${countryCode}${userName}`) === "") {
        message.destroy();
        message.error("手机号格式错误");
        return;
      }
      let { newName } = NewPhoneCheck(countryCode, userName);
      let isRegist = await isRegister(`${countryCode}-${newName}`);
      if (!isRegist) {
        message.destroy();
        message.error("此手机号尚未注册");
        return;
      }
    }
    if (isNeedGraph && captchaValue === "") {
      message.error("请输入图形验证码");
      return;
    }
    if (!checked && !checkFn({ userName })) {
      message.destroy();
      message.error("格式错误");
      return;
    }

    if (userName.match(/@/g) !== null) {
      value = { ...value, email: userName };
    } else {
      value = isNeedGraph
        ? {
            ...value,
            mobileNumber: userName,
            captchaId,
            countryCode,
            captchaValue,
          }
        : {
            ...value,
            mobileNumber: userName,
            countryCode,
          };
    }
    let { email } = value;
    let res;
    if (email) {
      res = await Axios.post("/captcha/email", value);
    } else {
      res = await Axios.post("/v2/captcha/sms", value);
    }
    if (res.data.code !== 0) {
      message.destroy();
      message.error(res.data.message);
      dispatch({ hasError: true });
      // SetButton();
    } else {
      message.success("发送成功");
      dispatch({ isSend: true });
      SetButton();
    }
  }, [
    userName,
    countryCode,
    action,
    checked,
    isPhone,
    captchaValue,
    captchaId,
  ]);

  useEffect(() => {
    str = true;
    !isNeedGraph && BuildCaptcha();
    return () => {
      str = false;
    };
  }, [isNeedGraph, BuildCaptcha]);
  return (
    <div style={{ float: "left", width: "40%" }}>
      {code === 0 ? (
        <Button
          onClick={BuildCaptcha}
          text={"获取验证码"}
          type="button"
          className="yzm_bt"
        />
      ) : (
        <Button
          type="button"
          text={`重发验证码(${code})`}
          className="yzm_bt_active"
        />
      )}
    </div>
  );
};
const SliderComponent = (props) => {
  const DivRef = useRef();

  const [Left, setLeft] = useState(0);

  useEffect(() => {
    if (!props.state) {
      setLeft(0);
    }
  }, [props.state]);

  const Move = (event) => {
    if (props.state === true) return;
    var diffX =
      (event.clientX || event.touches[0].pageX) - DivRef.current.offsetLeft;
    let start = false;
    if (event.type === "touchstart") {
      document.ontouchmove = (e) => {
        var moveX = (e.clientX || e.touches[0].pageX) - diffX;
        if (moveX < 0) {
          moveX = 0;
        } else if (moveX > 266 - DivRef.current.offsetWidth) {
          if (!start) {
            setLeft(266 - DivRef.current.offsetWidth);
            start = true;
            props.onChange({ state: true });
            return;
          }
          return;
        }
        !start && setLeft(moveX);
      };
      document.ontouchend = () => {
        document.ontouchmove = null;
        !start && setLeft(0);
      };
    } else {
      event.preventDefault();
      document.onmousemove = (e) => {
        var moveX = (e.clientX || e.touches[0].pageX) - diffX;
        if (moveX < 0) {
          moveX = 0;
        } else if (moveX > 266 - DivRef.current.offsetWidth) {
          if (!start) {
            setLeft(266 - DivRef.current.offsetWidth);
            start = true;
            props.onChange({ state: true });
            return;
          }
          return;
        }
        !start && setLeft(moveX);
      };
      document.onmouseup = () => {
        document.onmousemove = null;
        !start && setLeft(0);
      };
    }
  };

  return !props.state ? (
    <div className="horizontal-slider" style={{ touchAction: "none" }}>
      <div className="horizontal-slider_text">请按住滑块,拖动到最右边</div>
      <div
        className="horizontal-slider_ng"
        style={{ background: "#52c41a", width: Left + "px" }}
      ></div>
      <div
        ref={DivRef}
        onMouseDown={Move}
        onTouchStart={Move}
        style={{ left: Left + "px", cursor: "pointer" }}
        className="thumb"
      >
        {">>"}
      </div>
    </div>
  ) : (
    <div className="horizontal-slider" style={{ background: "#52c41a" }}>
      <div style={{ color: "#fff" }}>验证通过</div>
      <div
        ref={DivRef}
        onMouseDown={Move}
        onTouchStart={Move}
        style={{ left: Left + "px" }}
        className="thumb"
      >
        <Icon type="check" />
      </div>
    </div>
  );
};

const MergeCaptachAndGraphCapcha = (props) => {
  const [graph, setGraph] = useState({ captchaId: "", image: "" });
  const [twoValue, setValue] = useState({ graphValue: "", phoneValue: "" });
  let [code, setCode] = useState(0);
  let { countryCode, userName, dispatch, action, checked, isPhone } = props;
  var str = true;
  const getGraph = async () => {
    let res = await Getgraph();
    if (res.code !== 0) {
      message.error(res.message);
    } else {
      setValue((state) => ({ ...state, graphValue: "", phoneValue: "" }));
      dispatch({ captcha: "" });
      setGraph((state) => ({
        ...state,
        captchaId: res.data.captchaId,
        image: res.data.image,
      }));
    }
  };

  const SetButton = (index = 59) => {
    setCode(60);
    var timer = setInterval(() => {
      if (str) {
        setCode(index--);
      }
      if (index < 0 || !str) {
        clearInterval(timer);
      }
    }, 1000);
  };
  useEffect(() => {
    getGraph();
    return () => {
      str = false;
    };
  }, []);
  let { graphValue } = twoValue;
  let { captchaId } = graph;

  const BuildCaptcha = useCallback(async () => {
    let value = { action, unique: false };
    if (isPhone && userName === "") {
      message.destroy();
      message.error("请输入手机号");
      return;
    }
    if (userName !== "") {
      if (isPhone) {
        if (!userCheck(userName)) {
          message.destroy();
          message.error("格式错误");
          return;
        }
      }
    }

    if (isPhone) {
      if (passwordLogincheck(`${countryCode}${userName}`) === "") {
        message.destroy();
        message.error("手机号格式错误");
        return;
      }
      let { newName } = NewPhoneCheck(countryCode, userName);
      let isRegist = await isRegister(`${countryCode}-${newName}`);
      if (!isRegist) {
        message.destroy();
        message.error("此手机号尚未注册");
        return;
      }
    }
    if (graphValue === "") {
      message.error("请输入图形验证码");
      return;
    }
    if (!checked && !checkFn({ userName })) {
      message.destroy();
      message.error("格式错误");
      return;
    }

    if (userName.match(/@/g) !== null) {
      value = { ...value, email: userName };
    } else {
      value = {
        ...value,
        mobileNumber: userName,
        captchaId,
        countryCode,
        captchaValue: graphValue,
      };
    }
    let { email } = value;
    let res;
    if (email) {
      res = await Axios.post("/captcha/email", value);
    } else {
      res = await Axios.post("/v2/captcha/sms", value);
    }
    if (res.data.code !== 0) {
      message.destroy();
      message.error(res.data.message);
      getGraph();
      // SetButton();
    } else {
      message.success("发送成功");
      SetButton();
    }
  }, [userName, countryCode, action, checked, isPhone, graphValue, captchaId]);

  return (
    <div>
      <div style={{ margin: "10px 0", overflow: "hidden" }}>
        <Input
          style={{ width: "60%", float: "left" }}
          value={twoValue.graphValue}
          onChange={({ target: { value } }) => {
            setValue((state) => ({
              ...state,
              graphValue: value,
            }));
          }}
          placeholder="请输入右侧验证码"
        />
        <div style={{ float: "left", width: "40%" }}>
          <div
            onClick={() => {
              getGraph();
            }}
          >
            <img
              src={graph.image}
              width={"106px"}
              height={"36px"}
              style={{ objectFit: "contain" }}
            />
          </div>
        </div>
      </div>
      <div style={{ margin: "10px 0", overflow: "hidden" }}>
        <Input
          style={{ width: "60%", float: "left" }}
          value={twoValue.phoneValue}
          placeholder="请输入短信验证码"
          onChange={({ target: { value } }) => {
            setValue((state) => ({ ...state, phoneValue: value }));
            dispatch({ captcha: value });
          }}
        />
        <div style={{ float: "left", width: "40%" }}>
          {code === 0 ? (
            <Button
              onClick={BuildCaptcha}
              text={"获取验证码"}
              type="button"
              className="yzm_bt"
            />
          ) : (
            <Button
              type="button"
              text={`重发验证码(${code})`}
              className="yzm_bt_active"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export {
  UserInputComponent,
  PassWordComponent,
  CaptchaComponent,
  CaptchaComponentRegist,
  SliderComponent,
  GraphCaptach,
  CaptchaComponentLogin,
  MergeCaptachAndGraphCapcha,
};

const checkFn = (value) => {
  let { userName } = value;

  if (userName.match(/@/g) !== null) {
    return emailCheck(userName);
  }
  return true;
};

function userCheck(user) {
  return user.match(/\D/g) !== null ? false : true;
}
//邮箱验证
